import { enableProdMode, provideZonelessChangeDetection } from '@angular/core';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { init } from '@sentry/angular';
import { HttpErrorResponse } from '@angular/common/http';
import { platformBrowser } from '@angular/platform-browser';
import 'moment/locale/de';

const serverErrorsRegex = new RegExp(
    '500 Internal Server Error|401 Unauthorized|403 Forbidden|404 Not Found|502 Bad Gateway|503 Service Unavailable',
    'mi',
);

init({
    dsn: environment.sentry.dsn,
    environment: environment.sentry.environment,
    enabled: environment.sentry.enabled,
    beforeSend: (event, hint) => {
        // Handled by NgModule's ErrorHandler
        if (hint?.originalException instanceof HttpErrorResponse) {
            return null;
        }
        return event;
    },
    ignoreErrors: [
        serverErrorsRegex,
    ],
});

if (environment.production) {
    enableProdMode();
}

platformBrowser().bootstrapModule(
    AppModule,
    {
        applicationProviders: [
            provideZonelessChangeDetection(),
        ],
    },
).catch(err => console.log(err));
